export default __webpack_public_path__ + "static/media/tab_9.52616524.svg";